const AciHighwayTransactionApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/transaction/get`
};

export default AciHighwayTransactionApiUrls
